import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
    setSuccess('');
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      setError('Please fill in all fields.');
      return;
    }
    setSuccess('Thank you for contacting us! We will get back to you soon.');
    setForm({ name: '', email: '', message: '' });
  };

  return (
    <div className="contact-page">
      <section className="contact-hero">
        <h1>Contact Us</h1>
        <p>We'd love to hear from you! Reach out with your questions, feedback, or partnership inquiries.</p>
      </section>
      <div className="contact-content">
        <div className="contact-form-card">
          <h2>Send a Message</h2>
          <form onSubmit={handleSubmit} className="contact-form">
            <label>Name
              <input type="text" name="name" value={form.name} onChange={handleChange} required />
            </label>
            <label>Email
              <input type="email" name="email" value={form.email} onChange={handleChange} required />
            </label>
            <label>Message
              <textarea name="message" value={form.message} onChange={handleChange} required rows={5} />
            </label>
            {error && <div className="form-error">{error}</div>}
            {success && <div className="form-success">{success}</div>}
            <button type="submit" className="contact-submit-btn">Send</button>
          </form>
        </div>
        <div className="contact-info-card">
          <h2>Contact Information</h2>
          <div className="contact-info-list">
            <div className="contact-info-item"><i className="fas fa-envelope"></i> support@letscodebrain.com</div>
            <div className="contact-info-item"><i className="fas fa-phone"></i> +91 98765 43210</div>
            <div className="contact-info-item"><i className="fas fa-map-marker-alt"></i> 123, Main Street, New Delhi, India</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact; 